import {AfterViewInit, Component, Injector, Input, ViewEncapsulation} from '@angular/core';

import {FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';
import {NgFormControl}                                         from '../NgFormControl';


@Component({
    selector     : 'phone',
    template: `<div class="form-group validate-input">

    <label [for]="getFor()">{{label}}</label>
    <br/>
    <div *ngIf="control">
        <div class="input-group ng-control" [class.ng-invalid]="control.invalid"
             [class.ng-valid]="control.valid"
             [class.ng-touched]="control.touched">
            <div class="input-group-prepend">
                <div class="input-group-text">
                    <span class="fa fa-phone"></span>
                </div>
            </div>
            <input #part1 class="form-control" type="text" size="3" minlength="3" maxlength="3"
                   [attr.id]="identifier + '-part1'"
                   [(ngModel)]="phoneForm.part1"
                   pattern="\d{3}"
                   required
                   (keyup)="onKeyUp($event, part1, part2)"
                   (change)="format()"
                   (blur)="format()"
                   [attr.name]="identifier + '-part1'"
                   [name]="identifier + '-part1'"/>
            <div class="input-group-append">
                <span class="input-group-text">-</span>
            </div>
            <input #part2 class="form-control" type="text" size="3" minlength="3" maxlength="3"
                   [attr.id]="identifier + '-part2'"
                   [(ngModel)]="phoneForm.part2"
                   pattern="\d{3}"
                   required
                   (keyup)="onKeyUp($event, part2, part3)"
                   (change)="format()"
                   (blur)="format()"
                   [attr.name]="identifier + '-part2'"
                   [name]="identifier + '-part2'"/>
            <div class="input-group-append">
                <span class="input-group-text">-</span>
            </div>
            <input #part3 class="form-control" type="text" size="4" minlength="4" maxlength="4"
                   [attr.id]="identifier + '-part3'"
                   required
                   [(ngModel)]="phoneForm.part3"
                   pattern="\d{4}"
                   (keyup)="format()"
                   (change)="format()"
                   (blur)="format()"
                   [attr.name]="identifier + '-part3'"
                   [name]="identifier + '-part3'"/>
        </div>
        <div class="validation-messages-container">
            <div class="alert alert-danger" *ngIf="control && control.invalid && control.touched">
                <div>The {{label}} is not fully provided.</div>
            </div>
        </div>
    </div>
</div>
`,
    styles: [`@-webkit-keyframes shake{10%,90%{-webkit-transform:translate3d(-1px,0,0);transform:translate3d(-1px,0,0)}20%,80%{-webkit-transform:translate3d(2px,0,0);transform:translate3d(2px,0,0)}30%,50%,70%{-webkit-transform:translate3d(-4px,0,0);transform:translate3d(-4px,0,0)}40%,60%{-webkit-transform:translate3d(4px,0,0);transform:translate3d(4px,0,0)}}@keyframes shake{10%,90%{-webkit-transform:translate3d(-1px,0,0);transform:translate3d(-1px,0,0)}20%,80%{-webkit-transform:translate3d(2px,0,0);transform:translate3d(2px,0,0)}30%,50%,70%{-webkit-transform:translate3d(-4px,0,0);transform:translate3d(-4px,0,0)}40%,60%{-webkit-transform:translate3d(4px,0,0);transform:translate3d(4px,0,0)}}.validation-messages-container{position:relative;width:100%;display:block}.validation-messages-container .alert{position:absolute;bottom:24px;-webkit-box-shadow:2px 2px 5px 0 rgba(0,0,0,.2);box-shadow:2px 2px 5px 0 rgba(0,0,0,.2);width:auto;padding:5px 10px;max-width:100%;-webkit-animation:.5s cubic-bezier(.36,.07,.19,.97) both shake;animation:.5s cubic-bezier(.36,.07,.19,.97) both shake;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);cursor:pointer;font-size:.8em}@media (max-width:600px){.validation-messages-container .alert{font-size:.9em}}.validation-messages-container .alert.dismissed{display:none}.validation-messages-container .alert ul{list-style:none;margin:0;padding:0}.validation-messages-container .alert ul li{margin:0}`],
    encapsulation: ViewEncapsulation.None,
    providers    : [{
        provide    : NG_VALUE_ACCESSOR,
        useExisting: PhoneComponent,
        multi      : true
    }]
})

export class PhoneComponent extends NgFormControl<string> {
    @Input() name: string      = '';
    @Input() label: string     = 'Phone Number';
    @Input() disabled: boolean = false;
    @Input() required: boolean = false;

    @Input() parentFormControl: FormControl;
    @Input() parentFormGroup: FormGroup;

    additionalValidators = <any[]>[
        Validators.pattern('\\d{3}\\-\\d{3}\\-\\d{4}')
    ];

    phoneForm = {
        part1: '',
        part2: '',
        part3: ''
    };

    identifier = `phone-${identifier++}`;


    constructor(public injector: Injector) {
        super(injector);
    }

    onLoad() {
        if (this.value && this.value.length > 0) {
            let phone            = this.value.replace(/[^\d\-]+/g, '').split('-');
            this.phoneForm.part1 = phone[0];
            this.phoneForm.part2 = phone[1] || '';
            this.phoneForm.part3 = phone[2] || '';
        }
    }

    getFor() {
        let field = 'part1';
        if (this.phoneForm.part1.length > 2) {
            field = 'part2';

            if (this.phoneForm.part2.length > 2) {
                field = 'part3';

                if (this.phoneForm.part3.length > 3) {
                    field = 'extension';
                }
            }
        }
        return field;
    }

    format() {
        this.value = this.phoneForm.part1;
        if (this.phoneForm.part1.length === 3) {
            this.value += '-' + this.phoneForm.part2;
        }
        if (this.phoneForm.part2.length === 3) {
            this.value += '-' + this.phoneForm.part3;
        }
        this.control.markAsTouched();
        this.triggerValidation();
    }

    onKeyUp(event: KeyboardEvent, currentElement, nextElement) {
        let ignoreNextFocusKeys = ['tab', 'enter', 'backspace', 'arrowleft', 'arrowright', 'shift'];
        if (ignoreNextFocusKeys.indexOf(event.key.toLowerCase()) === -1 && nextElement && (currentElement.selectionStart === 3)) {
            nextElement.focus();
        }
        this.format();
    }
}

let identifier = 1;
